import * as React from 'react'
import { FC, useCallback, useState } from 'react'

import { ISalesFunnelSummaryReason } from '@user/store/salesFunnelSummary/typings'
import { ReasonsPopoverContent } from './ReasonsPopoverContent'
import { ToTitleCase } from '@user/utils/ToTitleCase'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import Popover from '@mui/material/Popover'
import Typography from '@mui/material/Typography'

const styles = {
  container: {
    width: '330px',
  },

  totalValue: {
    fontFamily: 'Source Sans Pro Semibold',
    fontSize: '28px',
  },
}

interface Props {
  count: number
  reasons: ISalesFunnelSummaryReason[]
  status: 'disqualified' | 'lost'
}

export const ReasonsPopover: FC<Props> = (props) => {
  const { count, reasons, status } = props

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const open = Boolean(anchorEl)
  const id = open ? 'total-value-popover' : undefined

  const onClose = useCallback(() => setAnchorEl(null), [])
  const onOpen = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget)
  }

  return (
    <>
      <IconButton color="primary" onClick={onOpen} size="small">
        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </IconButton>
      <Popover
        id={id}
        open={open}
        onClose={onClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{ onMouseLeave: onClose, elevation: 3 }}
      >
        <Box p={2} sx={styles.container}>
          <Grid container direction="column" justifyContent="center">
            <Grid item container>
              <Box display="flex" alignItems="center" flexGrow={1} pr={3}>
                <Box mr={3}>
                  <Typography>{ToTitleCase(status)}</Typography>
                </Box>
                <Typography sx={styles.totalValue}>{count}</Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <IconButton color="primary" onClick={onClose} size="small">
                  <KeyboardArrowUpIcon />
                </IconButton>
              </Box>
            </Grid>
            <ReasonsPopoverContent reasons={reasons} status={status} />
          </Grid>
        </Box>
      </Popover>
    </>
  )
}

ReasonsPopover.displayName = 'ReasonsPopover'
